<template>
  <div>
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="getIn">入库</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true" :btns="btns"
      :allBtnWidth="allBtnWidth" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <template slot="upanddown" slot-scope="params">
        <span :class="[params.params.upanddown >= 0 ? 'up' : 'down']">
          {{ `${params.params.upanddown >= 0 ? '+' : ''}${params.params.upanddown}` }}
        </span>
      </template>
    </Table>

    <FormDialog ref="dialog" :title="title" :width="'570px'" :labelWidth="'110px'" :form="mform" :formCtrl="mformCtrl"
      :viewMode="viewMode" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'stock',
      formInline: {},
      formCtrl: [
        {
          ...this.ctrls.month,
          label: '',
          keyName: 'intime',
          placeholder: '请填写查询时间',
        },
      ],
      cols: [
        { prop: "intime", label: "入库时间" },
        { prop: "inton", label: "入库重量", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "buyprice", label: "购入单价(元/吨)", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "buymoney", label: "购入金额", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "sellprice", label: "销售单价(元/升)", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "freight", label: "运费(元)", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "upanddown", label: "亏涨吨", align: 'right', className: 'pr30', slot: 'upanddown' },
      ],
      title: '入库',
      viewMode: false,
      mform: {},
      mformCtrl: [
        {
          label: "入库时间",
          keyName: "intime",
          err: "请填写入库时间",
          type: "date",
        },
        {
          label: "入库重量",
          keyName: "inton",
          err: "请填写入库重量",
          type: "number",
        },
        {
          label: "购入单价",
          keyName: "buyprice",
          err: "请填写购入单价",
          type: "number",
          unit: "元/吨",
        },
        {
          label: "购入金额",
          keyName: "buymoney",
          err: "请填写购入金额",
          type: "number",
        },
        {
          label: "销售单价",
          keyName: "sellprice",
          err: "请填写销售单价",
          type: "number",
          unit: "元/升",
        },
        {
          label: "运费",
          keyName: "freight",
          err: "请填写运费",
          type: "number",
        },
        {
          label: "盘库重量",
          keyName: "inventory",
          err: "请填写盘库重量",
          type: "number",
        },
      ],
    };
  },
  methods: {
    getIn() {
      this.mform = {}
      this.showDialog()
    },
    onModalSubmit(data) {
      // console.log({ ...data })
      // console.log({ ...this.mform })
      this.loading = true
      let url = `${this.baseUrl}/addedu`;
      const params = {
        ...data,
      }
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
.up {
  color: #67C23A;
}

.down {
  color: #F56C6C;
}

/deep/ .el-dialog {
  width: 40%;

  .el-form {
    .el-form-item {
      .content {
        position: relative;

        .el-date-editor.el-input,
        .el-input {
          width: 306px;
        }

        .unit {
          position: absolute;
          right: 20px;
          color: #C0C4CC;
        }
      }
    }
  }

  .btns {
    .mians {
      text-align: center;
    }
  }
}
</style>
